import classNames from "classnames";
import React, { ReactNode } from "react";

import { IButtonProps } from "../Button";
import { COMMON_UI_I18N } from "@Front/Components/DesignSystem/helpers/commonUiI18n";
import classes from "./classes.module.scss";
import { ModalBackdrop, ModalInner } from "./modalSubcomponents";

type IProps = {
	className?: string;
	isOpen: boolean;
	onClose?: () => void;
	children?: ReactNode;
	title?: string;
	firstButton?: IButtonProps;
	secondButton?: IButtonProps;
	thirdButton?: IButtonProps;
	fullwidth?: boolean;
	fullscreen?: boolean;
	fullheight?: boolean;
};

export default function Modal(props: IProps): React.ReactElement | null {
	const { isOpen, onClose, children, className, title, firstButton, secondButton, thirdButton, fullwidth, fullscreen, fullheight } =
		props;

	if (!isOpen) return null;

	const contentClassNames = classNames(
		classes["content"],
		className,
		fullwidth && classes["fullwidth"],
		fullscreen && classes["fullscreen"],
		fullheight && classes["fullheight"],
	);

	const closeLabel = COMMON_UI_I18N.iconButtonAccessibilityLabels.closeDialog;

	return (
		<div className={classes["root"]}>
			<ModalBackdrop onClose={onClose} closeLabel={closeLabel} />
			<ModalInner
				contentClassNames={contentClassNames}
				className={className}
				title={title}
				children={children}
				firstButton={firstButton}
				secondButton={secondButton}
				thirdButton={thirdButton}
				onClose={onClose}
				closeLabel={closeLabel}
			/>
		</div>
	);
}
